// Generated by CoffeeScript 1.12.7
(function() {
  var VASTResponse;

  VASTResponse = (function() {
    function VASTResponse() {
      this.ads = [];
      this.errorURLTemplates = [];
    }

    return VASTResponse;

  })();

  module.exports = VASTResponse;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ../~/vast-client/dist/response.js
// module id = 69
// module chunks = 0